import React from 'react';
import { useAppStore } from '@/lib/store';

export default function Header() {
  const { isSidebarOpen, setSidebarOpen, systemStatus, setActiveView } = useAppStore();

  const isOnline = systemStatus.overall === 'online';

  return (
    <header className="bg-[#232426] border-b border-[#515153] h-[48px] flex items-center justify-between px-3 md:px-4 flex-shrink-0 text-[13px] z-20">
      <div className="flex items-center gap-3 md:gap-5 h-full">
        {!isSidebarOpen && (
          <button onClick={() => setSidebarOpen(true)} className="text-[#b3b4b7] hover:text-white transition-colors flex items-center justify-center -ml-1 md:-mr-2" title="Expand Sidebar">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 12h18M3 6h18M3 18h18" /></svg>
          </button>
        )}
        <button onClick={() => setActiveView('overview')} className="flex items-center text-white font-bold text-[17px] md:text-[19px] tracking-tight hover:opacity-80 transition-opacity">
          <span className="text-[#F6661E] mr-[1px]">P</span>alinos
        </button>
      </div>

      <div className="flex items-center gap-3 md:gap-4 text-[#b3b4b7] font-medium h-full">
        <button className="hover:text-white items-center justify-center hidden sm:flex">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>
        </button>
        <a href="#" className={`flex items-center transition-colors gap-1.5 h-full ${isOnline ? 'text-[#71e184] hover:text-[#9af0a8]' : 'text-[#F6661E] hover:text-[#ff7b36]'}`}>
          <span className={`w-2 h-2 rounded-full flex-shrink-0 ${isOnline ? 'bg-[#71e184] status-online' : 'bg-[#F6661E]'}`}></span>
          <span className="hidden sm:inline">{isOnline ? 'Online' : 'Offline'}</span>
        </a>
        <a href="#" className="flex items-center gap-2 hover:text-white transition-colors h-full">
          <span className="text-[12px] md:text-[12.5px] tracking-wide uppercase hidden sm:inline">ADMIN</span>
          <div className="w-6 h-6 rounded-full bg-[#3e3f42] border border-[#515153] flex items-center justify-center text-white text-[10px] font-bold">GB</div>
        </a>
      </div>
    </header>
  );
}
